import styled from "styled-components";
export const FormSignUp = styled.form`
  height: 700px;
  width: 100%;
  border-radius: 15px;
  background-color: #212529;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;
